import type { PropsWithChildren } from "react";
import { NewMorphemeLessonLayoutContext } from "#new-morpheme-lesson-layout-context";
import { useNewMorphemeLessonLayoutContextValue } from "#new-morpheme-lesson-layout-context-value";

export function NewMorphemeLessonLayoutContextProvider({
  children,
  ...props
}: PropsWithChildren<Parameters<typeof useNewMorphemeLessonLayoutContextValue>[0]>) {
  const value = useNewMorphemeLessonLayoutContextValue(props);
  return (
    <NewMorphemeLessonLayoutContext.Provider value={value}>
      {children}
    </NewMorphemeLessonLayoutContext.Provider>
  );
}
